var exports = {
  "zr": "x93eb46d8--58481d--root",
  "Qq": "x93eb46d8--58481d--text",
  "Kk": "x93eb46d8--58481d--icon",
};

module.exports = exports;
